// src/components/Home.js
import React from "react";
import { Header } from "../components/header";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Projects } from "../components/projects";
import { Testimonials } from "../components/testimonials";
import { BlogSection } from "../components/blog-section";
import { Contact } from "../components/contact";


export const HomePage = ({ landingPageData }) => {
  return (
    <>
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Services/>
      <Projects />
      <Testimonials/>
      <BlogSection/>
      <Contact data={landingPageData.Contact} />
    </>
  );
};